<!-- LOGIN SCREEN PREMIUM DARK -->
<div
    class="min-h-screen bg-slate-50 flex items-center justify-center lg:justify-end p-6 lg:p-24 relative overflow-hidden font-sans">

    <!-- Animated Background Network / Bridges -->
    <div class="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <!-- Subtle Tech Grid -->
        <div
            class="absolute inset-0 bg-[linear-gradient(rgba(99,102,241,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(99,102,241,0.03)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_10%,transparent_100%)]">
        </div>

        <!-- Ambient Glows -->
        <div
            class="absolute top-[20%] left-[20%] w-[600px] h-[600px] bg-indigo-600/10 rounded-full blur-[120px] mix-blend-screen">
        </div>
        <div
            class="absolute bottom-[10%] right-[10%] w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[120px] mix-blend-screen">
        </div>

        <!-- SVG Network Map -->
        <svg viewBox="0 0 1920 1080" class="absolute inset-0 w-full h-full opacity-60"
            preserveAspectRatio="xMidYMid slice">
            <defs>
                <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="8" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
                <filter id="glow-small" x="-20%" y="-20%" width="140%" height="140%">
                    <feGaussianBlur stdDeviation="4" result="blur" />
                    <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
            </defs>
            <g stroke="rgba(99, 102, 241, 0.15)" stroke-width="2" fill="none">
                <path d="M-100,540 L2020,540" stroke-dasharray="10 10" class="opacity-30" />
                <path d="M200,540 L500,200 L960,540 L1420,200 L1720,540" />
                <path d="M200,540 L500,880 L960,540 L1420,880 L1720,540" />
                <path d="M500,200 L500,880" />
                <path d="M1420,200 L1420,880" />
                <path d="M500,200 L1420,200" />
                <path d="M500,880 L1420,880" />
                <path d="M200,540 L960,200 L1720,540" class="opacity-40" />
                <path d="M200,540 L960,880 L1720,540" class="opacity-40" />
            </g>
            <g fill="#3730a3">
                <circle cx="200" cy="540" r="8" filter="url(#glow-small)" />
                <circle cx="500" cy="200" r="6" />
                <circle cx="500" cy="880" r="6" />
                <circle cx="1420" cy="200" r="6" />
                <circle cx="1420" cy="880" r="6" />
                <circle cx="1720" cy="540" r="8" filter="url(#glow-small)" />
                <circle cx="960" cy="200" r="4" />
                <circle cx="960" cy="880" r="4" />
                <circle cx="960" cy="540" r="16" fill="#4f46e5" filter="url(#glow)" />
                <circle cx="960" cy="540" r="8" fill="#c084fc" />
            </g>
            <circle r="5" fill="#818cf8" filter="url(#glow-small)">
                <animateMotion dur="12s" repeatCount="indefinite"
                    path="M200,540 L500,200 L960,540 L1420,200 L1720,540" />
            </circle>
            <circle r="4" fill="#c084fc" filter="url(#glow-small)">
                <animateMotion dur="15s" begin="2s" repeatCount="indefinite"
                    path="M1720,540 L1420,880 L960,540 L500,880 L200,540" />
            </circle>
            <circle r="4" fill="#60a5fa" filter="url(#glow-small)">
                <animateMotion dur="8s" begin="1s" repeatCount="indefinite" path="M500,200 L1420,200" />
            </circle>
            <circle r="3" fill="#38bdf8" filter="url(#glow-small)">
                <animateMotion dur="9s" begin="4s" repeatCount="indefinite" path="M1420,880 L500,880" />
            </circle>
            <circle r="6" fill="#e879f9" filter="url(#glow-small)">
                <animateMotion dur="10s" begin="0s" repeatCount="indefinite" path="M-100,540 L2020,540" />
            </circle>
            <circle r="3" fill="#818cf8">
                <animateMotion dur="4s" begin="2s" repeatCount="indefinite" path="M500,200 L500,880" />
            </circle>
            <circle r="3" fill="#c084fc">
                <animateMotion dur="5s" begin="1s" repeatCount="indefinite" path="M1420,880 L1420,200" />
            </circle>
        </svg>
    </div>

    <!-- Left Side Branding (Visible on Desktop) -->
    <div
        class="hidden lg:flex flex-col items-start absolute left-24 top-1/2 -translate-y-1/2 z-10 max-w-lg animate-fade-in">
        <div
            class="w-20 h-20 rounded-3xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-[0_0_40px_rgba(99,102,241,0.4)] mb-8 border border-indigo-400/30">
            <lucide-icon [img]="icons.Layers" class="w-10 h-10 text-white"></lucide-icon>
        </div>
        <h1 class="text-6xl font-black text-slate-900 tracking-tight mb-4 leading-tight">
            STOCK<br>
            <span class="text-black">MADERO</span> <span class="not-italic">🍔</span>
        </h1>
        <p class="text-slate-600 text-lg leading-relaxed">
            Gestão de cálculo MRP e produtos.
        </p>
    </div>

    <!-- Login Box (Right Aligned) -->
    <div
        class="w-full max-w-[420px] bg-white/80 backdrop-blur-xl border border-slate-200 rounded-[2rem] shadow-[0_0_50px_rgba(0,0,0,0.1)] p-8 sm:p-10 relative z-10 animate-fade-in-up lg:mr-12">

        <!-- Mobile Header -->
        <div class="flex flex-col items-center mb-10 lg:hidden">
            <div
                class="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white shadow-lg shadow-indigo-500/30 mb-5 relative">
                <lucide-icon [img]="icons.Layers" class="w-8 h-8 text-white"></lucide-icon>
            </div>
            <h2 class="text-3xl font-black text-slate-800 tracking-tight flex flex-col items-center">
                <span>STOCK</span>
                <span class="flex items-center gap-2 mt-1">
                    <span class="text-black">MADERO</span> <span>🍔</span>
                </span>
            </h2>
            <p class="text-sm font-medium text-slate-500 mt-2">Acesso ao sistema</p>
        </div>

        <div class="hidden lg:block mb-10">
            <h2 class="text-2xl font-bold text-slate-800">Bem-vindo(a) de volta</h2>
            <p class="text-slate-500 text-sm mt-1">Insira as suas credenciais para continuar.</p>
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="doLogin()" class="space-y-5">
            @if (loginError()) {
            <div
                class="bg-red-500/10 text-red-600 p-3.5 rounded-xl text-xs font-medium flex items-center gap-2 animate-fade-in border border-red-500/20">
                <lucide-icon [img]="icons.AlertCircle" class="w-4 h-4 shrink-0"></lucide-icon>
                {{ errorMessage() || 'Credenciais inválidas. Tente novamente.' }}
            </div>
            }
            <div class="space-y-1.5">
                <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-widest pl-1">E-mail</label>
                <div class="relative group">
                    <div
                        class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-600 transition-colors">
                        <lucide-icon [img]="icons.User" class="w-[18px] h-[18px]"></lucide-icon>
                    </div>
                    <input formControlName="username" type="text"
                        class="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-800 focus:bg-white focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all placeholder:text-slate-400"
                        placeholder="ex: madero">
                </div>
            </div>
            <div class="space-y-1.5">
                <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-widest pl-1">Senha</label>
                <div class="relative group">
                    <div
                        class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-indigo-600 transition-colors">
                        <lucide-icon [img]="icons.Lock" class="w-[18px] h-[18px]"></lucide-icon>
                    </div>
                    <input formControlName="password" type="password"
                        class="w-full pl-11 pr-4 py-3.5 bg-white border border-slate-200 rounded-xl text-sm font-medium text-slate-800 focus:bg-white focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none transition-all placeholder:text-slate-400"
                        placeholder="••••••••">
                </div>
            </div>
            <div class="flex items-center gap-2 px-1">
                <input formControlName="rememberMe" type="checkbox" id="rememberMe"
                    class="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer">
                <label for="rememberMe" class="text-xs font-medium text-slate-500 cursor-pointer select-none">Lembrar
                    credenciais</label>
            </div>
            <button type="submit" [disabled]="loginForm.invalid || isLoggingIn()"
                class="w-full bg-purple-700 text-white font-bold py-3.5 px-4 rounded-xl hover:bg-purple-800 hover:shadow-[0_0_20px_rgba(126,34,206,0.4)] focus:ring-4 focus:ring-purple-500/30 transition-all flex items-center justify-center gap-2 mt-6 disabled:opacity-50 disabled:hover:shadow-none disabled:cursor-not-allowed border border-purple-600/50">
                @if (isLoggingIn()) {
                <lucide-icon [img]="icons.Loader" class="w-[18px] h-[18px] animate-spin"></lucide-icon> Autenticando...
                } @else {
                Entrar
                }
            </button>
        </form>

        <div class="mt-8 text-center border-t border-slate-200 pt-6">
            <p class="text-[10px] font-medium text-slate-400 uppercase tracking-wider">GRUPO MADERO © 2026</p>
        </div>
    </div>
</div>